import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import AddUserModal from "./AddUserModal";
import ModalWidget from "../ModalWidget";
import { AccountType } from "../../../models/AccountType";
import { getClassroomById } from "../../../services/ClassroomService";
import { useMenu } from "../../../contexts/MenuContext";

/**
 * Route entry for `/class/:id/assign-student`. Fetches the classroom name so
 * the underlying choice modal locks the classroom context across all add flows
 * (Import File pre-fills `class_name`, Add Manually disables the dropdown,
 * Add Existing enrolls into this classroom).
 */
function AssignStudentEntry() {
    const { id } = useParams();
    const location = useLocation();
    const { navigateBack } = useMenu();
    const termId = (location.state as { termId?: string } | null)?.termId;
    const [classroomName, setClassroomName] = useState<string | undefined>(undefined);
    const [loadFailed, setLoadFailed] = useState(false);

    useEffect(() => {
        if (!id) return;
        let cancelled = false;
        setLoadFailed(false);
        getClassroomById(id)
            .then((c) => {
                if (!cancelled) setClassroomName(c.name);
            })
            .catch(() => {
                if (!cancelled) {
                    setClassroomName(undefined);
                    setLoadFailed(true);
                }
            });
        return () => { cancelled = true; };
    }, [id]);

    if (!id) return null;

    if (!classroomName) {
        return (
            <ModalWidget
                show
                loading={!loadFailed}
                title="Add Students"
                description={loadFailed ? 'Unable to load this class. Close and try again.' : undefined}
                hasFooter={false}
                navigateBack={false}
                onHide={navigateBack}
            />
        );
    }

    return (
        <AddUserModal
            userType={AccountType.STUDENT}
            classroomId={id}
            classroomName={classroomName}
            termId={termId}
            onHide={navigateBack}
        />
    );
}

export default AssignStudentEntry;
